import React from "react";
import { useParams } from "react-router";
import { Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import { useMunicipalityLoading } from "hooks/loading";
import MunicipalityLoadingView from "components/loading/MunicipalityLoadingView/MunicipalityLoadingView";
import { useContextPerson } from "hooks/persons";
import { Flags } from "utils";

export default function MunicipalityLoadingPage() {
    const { regionId, municipalityId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useMunicipalityLoading(municipalityId);

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/loading/region/${regionId}/`}
                        text={"Назад"}
                        name={"region_municipality_back_link"}
                    />
                )}

                <MunicipalityLoadingView
                    regionId={Number(regionId)}
                    municipalityId={Number(municipalityId)}
                    data={data}
                />
            </>
        );
    }
}
